// Color theory constants
const GOLDEN_RATIO = 0.618033988749895;
const PRIMARY_COLORS = [
  { h: 262, s: 83, l: 58 }, // Purple (primary brand color)
  { h: 210, s: 100, l: 56 }, // Blue
  { h: 142, s: 76, l: 47 }, // Green
  { h: 31, s: 95, l: 58 }, // Orange
  { h: 187, s: 100, l: 42 }, // Teal
];

// Utility function to calculate contrast ratio
const luminance = (r, g, b) => {
  const [rs, gs, bs] = [r, g, b].map(c => {
    c = c / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
};

const hslToRgb = (h, s, l) => {
  s /= 100;
  l /= 100;
  const k = n => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return [255 * f(0), 255 * f(8), 255 * f(4)].map(Math.round);
};

// Generate harmonious colors based on golden ratio
const generateHarmonious = (baseHue, count = 1) => {
  const hues = [];
  let hue = baseHue;
  for (let i = 0; i < count; i++) {
    hues.push(hue % 360);
    hue += 360 * GOLDEN_RATIO;
  }
  return hues;
};

export const generateDepartmentColor = () => {
  try {
    // Select a base color from predefined palette or generate one
    const baseColor = PRIMARY_COLORS[Math.floor(Math.random() * PRIMARY_COLORS.length)];
    
    // Generate harmonious hue variation
    const hue = generateHarmonious(baseColor.h)[0];
    
    // Use controlled saturation and lightness ranges for consistency
    const s = Math.floor(Math.random() * 15 + baseColor.s); // Stay close to base saturation
    const l = Math.floor(Math.random() * 10 + 85); // Keep high lightness for background
    
    // Calculate text color lightness for contrast
    const textL = Math.max(l - 45, 30); // Ensure sufficient contrast
    
    // Convert to RGB to check contrast ratio
    const bgRgb = hslToRgb(hue, s, l);
    const textRgb = hslToRgb(hue, s, textL);
    
    const bgLuminance = luminance(...bgRgb);
    const textLuminance = luminance(...textRgb);
    
    // Calculate contrast ratio
    const contrast = (Math.max(bgLuminance, textLuminance) + 0.05) /
                    (Math.min(bgLuminance, textLuminance) + 0.05);
    
    // If contrast is too low, adjust text lightness
    const finalTextL = contrast < 4.5 ? (l > 50 ? 30 : 95) : textL;
    
    return {
      bg: `hsla(${hue}, ${s}%, ${l}%, 0.2)`,
      text: `hsla(${hue}, ${s}%, ${finalTextL}%, 1)`
    };
  } catch (error) {
    console.error('Error generating department color:', error);
    // Fallback to a safe default color if something goes wrong
    return {
      bg: 'hsla(262, 83%, 95%, 0.2)',
      text: 'hsla(262, 83%, 45%, 1)'
    };
  }
};